import { EventEmitter, inject,Injectable } from '@angular/core';
import { Filter, Order, OrderType, Paginator, Search, SessionCookieService } from '@docpath/linces-angular-components/common';
import { Table, TableField, TableFieldLink, TableFieldText, TableRow } from '@docpath/webcomponents';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { Alias } from '../../models/alias';
import { AliasFormService } from '../../services/alias-form.service';
import { AliasHttpService } from '../../services/alias-http.service';

@Injectable({
    providedIn: 'root'
})
export class AliasTableService {

    aliasLoaded: EventEmitter<Alias[]> = new EventEmitter();
    private readonly i18nPrefix = 'alias-config.alias-row';
    private currentPage: number;
    private elements: number;
    private currentSize: number;
    private aliases: Alias[] = [];

    private readonly aliasHttpService = inject(AliasHttpService);
    private readonly aliasFormService = inject(AliasFormService);
    private readonly sessionCookieService = inject(SessionCookieService);
    private readonly cloudService = inject(CloudService);

    constructor() {
        this.currentPage = 1;
        this.elements = 0;
        this.currentSize = 25;
    }

    getCurrentPage(): number {
        return this.currentPage;
    }
    getElements(): number {
        return this.elements;
    }
    getAlises(): Alias[] {
        return this.aliases;
    }
    getCurrentSize(): number {
        return this.currentSize;
    }

    getSelectedAlias(table: Table): Alias[] {
        return table.body.filter(row => row.selected).map(row => row.content);
    }

    loadAlias(filters: Filter[], page = this.currentPage, size = this.currentSize): void {
        this.currentPage = page;
        this.currentSize = size;

        const search = new Search(filters, [new Order('alert_alias', OrderType.Asc)], [],
            new Paginator(page - 1, this.currentSize, this.elements));

        this.aliasHttpService.getAlias(search, (result, totalSize) => {
            this.elements = totalSize;
            this.aliases = result as Alias[];
            this.aliasLoaded.emit(result);
        });
    }


    initTable(): Table {
        const header = this.initTableHeader();
        const body = this.initTableBody([]);

        return new Table(header, body);
    }

    initTableHeader(): TableRow {

        const tableRow = new TableRow([]);

        tableRow.fields.push(new TableFieldText(`${this.i18nPrefix}.table.alias`, undefined, undefined, undefined, undefined, true));
        tableRow.fields.push(new TableFieldText(`${this.i18nPrefix}.table.email`, undefined, undefined, undefined, undefined, true));
        if (!this.cloudService.isModeCloud()) {
            tableRow.fields.push(new TableFieldText(`${this.i18nPrefix}.table.phone`, undefined, undefined, undefined, undefined, true));
        }

        return tableRow;

    }


    initTableBody(alias: Alias[]): TableRow[] {
        return alias.map(alias => {
            const fields: TableField[] = [],
                nameClickAction = () => this.aliasFormService.openEditAliasForm(alias);
            fields.push(new TableFieldLink(alias.alert_alias, alias.alert_alias, undefined, nameClickAction, alias.alert_alias));
            fields.push(new TableFieldText(alias.email, undefined, undefined));
            if (!this.cloudService.isModeCloud()) {
                fields.push(new TableFieldText(alias.phone_number || '', undefined, undefined));
            }

            const tableRow = new TableRow(fields);
            tableRow.content = alias;

            return tableRow;
        });
    }
}